<script lang="ts">
  export let type: string = 'text';
  export let placeholder: string = '';
  export let value: string = '';
  export let label: string = '';
  export let id: string | undefined = undefined;
  export let disabled: boolean = false;
  export let required: boolean = false;
  export let error: string | undefined = '';
  export let fullWidth: boolean = false;
  export let readonly: boolean = false;
  export let min: string | number | undefined = undefined;
  export let max: string | number | undefined = undefined;
  export let step: string | number | undefined = undefined;
  export let maxlength: number | undefined = undefined;
  export let inputmode: 'url' | 'text' | 'email' | 'decimal' | 'numeric' | 'search' | 'none' | 'tel' | null | undefined = undefined;

  $: fieldId = id ?? label;
</script>

<div class="input-wrapper" class:full-width={fullWidth}>
  {#if label}
    <label class="input-label" for={fieldId}>
      {label}
      {#if required}<span class="required">*</span>{/if}
    </label>
  {/if}
  
  {#if type === 'email'}
    <input
      type="email"
      {placeholder}
      {disabled}
      {readonly}
      {required}
      id={fieldId}
      class="input-field"
      class:error={error}
      bind:value
      on:input
      on:blur
      on:focus
      on:keydown
      on:keyup
    />
  {:else if type === 'date'}
    <input
      type="date"
      {placeholder}
      {disabled}
      {readonly}
      {required}
      id={fieldId}
      class="input-field"
      class:error={error}
      bind:value
      on:input
      on:blur
      on:focus
      on:keydown
      on:keyup
    />
  {:else if type === 'number'}
    <input
      type="number"
      {placeholder}
      {disabled}
      {readonly}
      {required}
      {min}
      {max}
      {step}
      id={fieldId}
      class="input-field"
      class:error={error}
      bind:value
      on:input
      on:blur
      on:focus
      on:keydown
      on:keyup
    />
  {:else}
    <input
      type="text"
      {placeholder}
      {disabled}
      {readonly}
      {required}
      id={fieldId}
      class="input-field"
      class:error={error}
      {maxlength}
      {inputmode}
      bind:value
      on:input
      on:blur
      on:focus
      on:keydown
      on:keyup
    />
  {/if}
  
  {#if error}
    <span class="error-message">{error}</span>
  {/if}
</div>

<style>
  .input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .full-width {
    width: 100%;
  }
  
  .input-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
  }
  
  .required {
    color: #ef4444;
  }
  
  .input-field {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 0.875rem;
    background-color: white;
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  
  .input-field:focus {
    outline: none;
    border-color: #f0b429;
    box-shadow: 0 0 0 3px rgba(240, 180, 41, 0.1);
  }
  
  .input-field:disabled {
    background-color: #f3f4f6 !important;
    color: black !important;
    border-color: #e5e7eb;
    cursor: not-allowed;
    /* opacity: 0.6; */
  }
  
  .input-field:read-only {
    background-color: #f9fafb;
    cursor: default;
  }
  
  .input-field.error {
    border-color: #ef4444;
  }
  
  .input-field.error:focus {
    border-color: #ef4444;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
  }
  
  .error-message {
    font-size: 0.75rem;
    color: #ef4444;
  }
</style> 